import React from 'react';

export default class NoResultFound extends React.Component {

    render() {
        return (
            <div className="container container--xnarrow text--18 text--center">

                <img src="/img/icon-alert--orange.svg" alt="" width="34" height="34" className="icon margin--20--bot" />
                <h3 className="text--light text--26 text--orange margin--20--bot">No results found</h3>
                <p>
                    Sorry, we couldn't find the member you’re looking for. Check your spelling is correct, or try using different details. E.g. A surname instead of email.
                </p>
            </div>
        )
    }
}
